// Configurações da própria conta: 2FA, senhas de aplicativo, sessões.

import { api } from "./cliente";
import type { Resposta } from "./tipos";

// O tipo vem do CONTRATO. Declarar à mão foi como eu inventei um envelope
// `{ itens: [...] }` que a API nunca devolveu. Ver tipos.ts.
export const sessoesAbertas = () => api.get<Resposta<"/auth/sessoes">>("/auth/sessoes");
export const encerrarSessao = (uuid: string) => api.delete<void>(`/auth/sessoes/${uuid}`);

/**
 * Iniciar o 2FA NÃO o ativa: devolve o segredo e o QR, e a proteção só passa a
 * valer depois de confirmar com um código válido. Sem essa etapa, um QR lido
 * errado trancaria o usuário fora da própria conta.
 */
export const iniciar2FA = () =>
  api.post<Resposta<"/auth/2fa", "post"> & { senhas_app_ativas?: number; aviso?: string }>(
    "/auth/2fa",
  );

export const confirmar2FA = (codigo: string) =>
  api.post<Resposta<"/auth/2fa/confirmar", "post"> & { aviso?: string }>(
    "/auth/2fa/confirmar",
    { codigo },
  );

/** Desativar exige a senha atual: sessão roubada não desliga a proteção. */
export const desativar2FA = (senha: string) => api.delete<void>("/auth/2fa", { senha });

export const senhasApp = () => api.get<Resposta<"/auth/senhas-app">>("/auth/senhas-app");

/** A senha em claro aparece UMA vez, na resposta. Depois só o hash existe. */
export const criarSenhaApp = (descricao: string) =>
  api.post<Resposta<"/auth/senhas-app", "post">>("/auth/senhas-app", { descricao });

export const revogarSenhaApp = (uuid: string) =>
  api.delete<void>(`/auth/senhas-app/${uuid}`);

// ---------------------------------------------------------------------------
// Preferências da caixa. Sem uuid na rota: o escopo é a própria sessão.
// ---------------------------------------------------------------------------

export const assinatura = () => api.get<Resposta<"/conta/assinatura">>("/conta/assinatura");
export const salvarAssinatura = (texto: string) =>
  api.put<Resposta<"/conta/assinatura", "put">>("/conta/assinatura", { texto });

export const respostaAutomatica = () =>
  api.get<Resposta<"/conta/resposta-automatica">>("/conta/resposta-automatica");
export const salvarRespostaAutomatica = (
  dados: NonNullable<Resposta<"/conta/resposta-automatica">>,
) => api.put<Resposta<"/conta/resposta-automatica", "put">>("/conta/resposta-automatica", dados);

export const filtros = () => api.get<Resposta<"/conta/filtros">>("/conta/filtros");
export const salvarFiltros = (lista: NonNullable<Resposta<"/conta/filtros">>) =>
  api.put<Resposta<"/conta/filtros", "put">>("/conta/filtros", lista);
